import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3 20.0001H4C3.46957 20.0001 2.96086 19.7894 2.58579 19.4143C2.21071 19.0392 2 18.5305 2 18.0001V5.0001C2 4.46966 2.21071 3.96096 2.58579 3.58588C2.96086 3.21081 3.46957 3.0001 4 3.0001H7.98C8.31449 2.99682 8.64445 3.07748 8.9397 3.23472C9.23495 3.39195 9.48604 3.62072 9.67 3.9001L10.33 5.1001C10.5121 5.37663 10.76 5.60362 11.0515 5.7607C11.343 5.91778 11.6689 6.00004 12 6.0001H20C20.5304 6.0001 21.0391 6.21081 21.4142 6.58588C21.7893 6.96096 22 7.46966 22 8.0001V11.3001",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 20V19.3333C19 18.9797 18.8495 18.6406 18.5816 18.3905C18.3137 18.1405 17.9503 18 17.5714 18H15.4286C15.0497 18 14.6863 18.1405 14.4184 18.3905C14.1505 18.6406 14 18.9797 14 19.3333V20",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 13C20.2863 13.0861 20.5398 13.2802 20.7208 13.5517C20.9018 13.8232 21 14.1567 21 14.5C21 14.8433 20.9018 15.1768 20.7208 15.4483C20.5398 15.7198 20.2863 15.9139 20 16",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 20V19.3186C21.9998 19.0166 21.9015 18.7233 21.7205 18.4846C21.5395 18.2459 21.286 18.0755 21 18",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 16C17.3284 16 18 15.3284 18 14.5C18 13.6716 17.3284 13 16.5 13C15.6716 13 15 13.6716 15 14.5C15 15.3284 15.6716 16 16.5 16Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFolderUsers;
